import React, { useState } from 'react';
import { SignIn } from 'components/Auth/forms/SignIn';
import { SignUp } from 'components/Auth/forms/SignUp';
import { ForgotPassword } from 'components/Auth/forms/ForgotPassword';
import style from './style.module.scss';

type AuthView = 'login' | 'signup' | 'forgot-password';

const Auth: React.FC = (): React.ReactElement => {
  const [view, setView] = useState<AuthView>('login');

  return (
    <div style={{ width: '100%' }}>
      {view === 'signup' && (
        <>
          <SignUp onSuccess={() => setView('login')} />
          <p className={style.have_account} onClick={() => setView('login')}>
            Already have an account? <span>Log in</span>
          </p>
        </>
      )}

      {view === 'login' && (
        <>
          <SignIn onForgotPassword={() => setView('forgot-password')} />
          <p className={style.have_account} onClick={() => setView('signup')}>
            Don&apos;t have an account? <span>Sign up</span>
          </p>
        </>
      )}

      {view === 'forgot-password' && (
        <ForgotPassword onBackToLogin={() => setView('login')} />
      )}
    </div>
  );
};

export default Auth;
